import { gql } from "apollo-boost";

export const COMMENT_ADD = gql`
  mutation($comment: AddCommentDto!) {
    addComment(comment: $comment) {
      id
    }
  }
`;

export const COMMENT_DELETE = gql`
  mutation($id: String!) {
    deleteComment(id: $id)
  }
`;

export const COMMENT_UPDATE = gql`
  mutation($comment: UpdateCommentDto!) {
    updateComment(comment: $comment)
  }
`;

export const COMMENT_GET = gql`
  query($id: String!, $take: Int, $skip: Int, $userId: String, $order: Order) {
    findParentComments(id: $id, take: $take, skip: $skip, order: $order) {
      count
      results {
        id
        content
        updated_at
        children {
          count
          results {
            id
            user {
              username
              avatarUrl
              id
            }
            updated_at
            content
            fatherId
            url
            likedTime {
              count
            }
            liked(ownerId: $userId) {
              status
            }
          }
        }
        user {
          id
          avatarUrl
          username
        }
        likedTime {
          count
        }
        liked(ownerId: $userId) {
          status
        }
      }
    }
  }
`;

export const COMMENT_GET_WITH_USER = gql`
  query($id: String!, $take: Int, $skip: Int, $userId: String!, $order: Order) {
    findParentComments: findParentCommentsWithUser(
      id: $id
      take: $take
      skip: $skip
      userId: $userId
      order: $order
    ) {
      count
      results {
        id
        content
        updated_at
        children {
          count
          results {
            id
            updated_at
            content
            fatherId
            url
            likedTime {
              count
            }
            liked(ownerId: $userId) {
              status
            }
          }
        }
        user {
          id
          avatarUrl
          username
        }
        likedTime {
          count
        }
        liked(ownerId: $userId) {
          status
        }
      }
    }
  }
`;

export const GQL_GET_COMMENTS = gql`
  query($take: Int, $skip: Int, $userId: String, $order: Order) {
    getComments(take: $take, skip: $skip, order: $order) {
      count
      results {
        id
        updated_at
        url
        user {
          username
          avatarUrl
          id
        }
        content
        liked(ownerId: $userId) {
          status
        }
        likedTime {
          count
        }
      }
    }
  }
`;

export const GQL_LOAD_COMMENTS = gql`
  query(
    $fatherIds: [String!]!
    $skip: Int
    $take: Int
    $userId: String
    $order: Order
  ) {
    findManyParentComments(
      skip: $skip
      take: $take
      ids: $fatherIds
      order: $order
    ) {
      fatherId
      count
      results {
        id
        updated_at
        content
        fatherId
        url
        likedTime {
          count
        }
        liked(ownerId: $userId) {
          status
        }
        user {
          username
          avatarUrl
          id
        }
        children {
          count
          results {
            id
            user {
              id
              username
              avatarUrl
            }
            updated_at
            content
            fatherId
            url
            likedTime {
              count
            }
            liked(ownerId: $userId) {
              status
            }
          }
        }
      }
    }
  }
`;

export const GQL_LOAD_COMMENTS_WITH_USER = gql`
  query(
    $fatherIds: [String!]!
    $skip: Int
    $take: Int
    $userId: String!
    $order: Order
  ) {
    findManyParentComments: findManyParentCommentsWithUser(
      skip: $skip
      take: $take
      ids: $fatherIds
      userId: $userId
      order: $order
    ) {
      fatherId
      count
      results {
        id
        updated_at
        content
        fatherId
        url
        likedTime {
          count
        }
        liked(ownerId: $userId) {
          status
        }
        user {
          id
          username
          avatarUrl
        }
        children {
          count
          results {
            id
            user {
              id
              username
              avatarUrl
            }
            updated_at
            content
            fatherId
            url
            likedTime {
              count
            }
            liked(ownerId: $userId) {
              status
            }
          }
        }
      }
    }
  }
`;

export const GQL_FIND_CHILD_COMMENTS = gql`
  query($skip: Int, $take: Int, $id: String!, $userId: String, $order: Order) {
    findChildComments(skip: $skip, take: $take, id: $id, order: $order) {
      results {
        liked(ownerId: $userId) {
          status
        }
        likedTime {
          count
        }
        id
        updated_at
        content
        fatherId
        url
        parentId
        user {
          avatarUrl
          username
          id
        }
      }
      count
    }
  }
`;
